import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import PageTitle from "../../Components/PageTitle";
import HostelFacilityBanner from "../../assets/HostelFacility.png";

const HostelFacility = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Hostel Facility - Shree Mangalam School"
        description="Discover the safe, hygienic, and well-managed hostel facility at Shree Mangalam School. Designed for student comfort and focus during RIMC and Military School exam preparation."
        url="/hostel-facility"
        keywords="hostel facility, school hostel, student accommodation, Shree Manglam hostel, RIMC coaching hostel"
      />

      <Header image={HostelFacilityBanner} alt={"Hostel Facility Banner"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Hostel Facility
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Shree Mangalam School offers separate, secure, and
          well-managed hostel facilities for both boys and girls. Our hostels
          are designed to provide a nurturing and disciplined environment that
          supports academic excellence and personal growth. With a focus on
          comfort, safety, and holistic development, the hostel becomes a second
          home where students learn to live independently while staying
          connected to their values.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Safe & Supervised Living:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Separate hostels for boys and girls, each under the care of
          experienced wardens and round-the-clock CCTV surveillance to ensure
          safety and discipline.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Clean & Comfortable Rooms:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Spacious, well-ventilated, and regularly sanitized rooms with
          essential furnishings to create a restful and organized living space.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Nutritious Meals:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Wholesome vegetarian meals served in a hygienic dining hall, planned
          to meet the dietary needs of growing students.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Structured Daily Routine:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          A well-balanced schedule that includes study time, recreation, and
          rest — fostering time management, responsibility, and discipline.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Academic Support:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Evening study hours with guidance from trained staff help students
          revise lessons, complete homework, and clear doubts.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Healthcare Services:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          On-campus infirmary, regular health checkups, and immediate medical
          attention available to ensure physical well-being.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Emotional & Moral Support:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Counseling, mentorship, and regular interaction with teachers build
          emotional resilience, confidence, and values.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          High Hygiene Standards:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Clean bathrooms, regular sanitization, safe drinking water, and strict
          hygiene protocols are maintained daily.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Cultural & Recreational Activities:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Students engage in indoor games, talent shows, festive celebrations,
          and weekend activities to balance academics and enjoyment.
        </Typography>
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Parent Communication:
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Regular updates about student progress, monthly reports, phone calls,
          and scheduled parent visits ensure transparency and trust.
        </Typography>
      </Container>

      <Footer />
    </>
  );
};

export default HostelFacility;
